import React, { useEffect, useRef, useState,useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Typography } from '@material-ui/core';
import { useStyles } from './Styles';
import SearchIcon from '@material-ui/icons/Search';
import {
  fetchBatcheProducts,
  newbatchProducts,
} from '../../../../../containers/actions/common/saslAction';
import { batchFilters } from '../../../../../containers/actions/common/filtersAction';
const SearchSelect = (props) => {
  const { searchQuery, handleSearchQuery, CMOMember, selectedCMOList, selectedMFGPlantList,selectedSponsorIds } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const [value, setValue] = useState(null);
  const [tempValue, setTempValue] = useState('');
  const [loading, setLoading] = useState(false);
  // let loading = true;

  useEffect(() => {
    // console.log("Inside useEffect search select.");

    let data = {
      searchProduct: tempValue.trim(),
      // vendorMosymphonyID: CMOMember,
      vendorMosymphonyIDList: selectedCMOList && selectedCMOList.length > 0 ? selectedCMOList : [],
      aslNumberList: selectedMFGPlantList && selectedMFGPlantList.length > 0 ? selectedMFGPlantList : [],
      brandOwnerMosymphonyIds: selectedSponsorIds

    };
    if (tempValue !== '') {
      dispatch(fetchBatcheProducts(data));
    }

    return () => {
      if (newbatchProducts) {
        newbatchProducts.cancel('leaving page!');
      }
    };
  }, [dispatch, tempValue, CMOMember, selectedCMOList, selectedMFGPlantList,selectedSponsorIds]);

    // Cleanup debounce timer on unmount
    useEffect(() => {
      return () => {
        if (debounceTimerRef.current) {
          clearTimeout(debounceTimerRef.current);
        }
      };
    }, []);
  

  const batchFilterValue = useSelector((state) => state.pcmp.common.filters);

  const firstLoad = useRef(true);
  useEffect(() => {
    if (
      batchFilterValue?.batchFilters?.productSearchValue &&
      firstLoad.current === true
    ) {
      firstLoad.current = false;
      setValue(batchFilterValue.batchFilters.productSearchValue);
    }
  }, [dispatch, batchFilterValue.batchFilters]);

  useEffect(() => {
    if (searchQuery === '') {
      setValue(null);
      setTempValue('');
    } else if (
      batchFilterValue?.batchFilters &&
      batchFilterValue?.batchFilters.productSearch !== ''
    ) {
      setValue(batchFilterValue.batchFilters.productSearchValue);
    }
  }, [searchQuery, batchFilterValue]);

  const Products = useSelector((state) => {
    if (
      state.pcmp.common.sasl.fetchBatchProducts.status === true &&
      state.pcmp.common.sasl.fetchBatchProducts.data
    ) {
      if (loading === true) setLoading(false);
      return state.pcmp.common.sasl.fetchBatchProducts.data;
    }
    if (
      state.pcmp.common.sasl.fetchBatchProducts.status === false &&
      state.pcmp.common.sasl.fetchBatchProducts.data
    ) {
      if (loading === true) setLoading(false);
      return [];
    }
    return [];
  });

  const onProductChange = (event, value) => {
    handleSearchQuery(value);
    setValue(value);
    dispatch(
      batchFilters({
        productSearchValue: value,
      })
    );
  };

  const debounceTimerRef = useRef(null);
  const debouncedSetTempValue =
  useCallback((inputValue) => {
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }
    
   
    debounceTimerRef.current = setTimeout(() => {
      setTempValue(inputValue);
    }, 1000);
  }, []);

  const onInputChange = (event) => {
    const inputValue = event.target.value;
    if (loading === false && inputValue !== '') 
      setLoading(true);
    if (inputValue === '') {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
      handleSearchQuery(inputValue);
      setTempValue('');
    } else {
      debouncedSetTempValue(inputValue);
    }
  };

  // Check if user is CMO to display CMO-specific fields
  const isCMO = localStorage.getItem('collabType') === "CMO";

  // Function to get the display label for options
  const getOptionLabel = (option) => {
    if (isCMO) {
      const code = option.cmoFGMaterialCode || '';
      const name = option.cmoFGMaterialName || '';
      if (code && name) {
        return `${code} / ${name}`;
      }
      return code || name || '';
     
    }

    const code = option.fgMaterialCode || '';
    const name = option.fgMaterialName || '';
    if (code && name) {
      return `${code} / ${name}`;
    }
    return code || name || '';
  };
  // Filter out products with empty code and name
  const filteredProducts = tempValue === '' ? [] : Products.filter((option) => {
    if (isCMO) {
      const code = option.cmoFGMaterialCode || '';
      const name = option.cmoFGMaterialName || '';
      return code || name;
    }
    const code = option.fgMaterialCode || '';
    const name = option.fgMaterialName || '';
    return code || name;
  });

  return (

      <Grid>
        <Typography variant='body2' className={classes.filterField}>
          Select Product:
        </Typography>
     <React.Fragment className={classes.filterFieldValue}>
        <Autocomplete
          className={classes.root}
          id='SearchProduct'
          options={filteredProducts}
          value={value}
          // disableClearable
          onChange={onProductChange}
          // onInputChange={onInputChange}
           getOptionLabel={getOptionLabel}
          clearOnBlur={false}
          loading={loading}
          loadingText='Loading....'
          noOptionsText={
            tempValue
              ? 'No match found. Please try different search.'
              : 'Please Enter Material Code / Description'
          }
          renderInput={(params) => (
            <TextField
              {...params}
              style={{ fontSize: '0.875rem' }}
              margin='normal'
              placeholder='Search using Material Code / Description'
              InputProps={{
                ...params.InputProps,
                startAdornment: <SearchIcon />,
              }}
              onChange={onInputChange}
            />
          )}
        />
    </React.Fragment>
       </Grid>
  );
};

export default SearchSelect;
